export { default } from './CategoryDetailLeft';
